import { apiCall, ApiParams, ApiResps } from 'providers';
import { defaultConsumptionFormValue, months } from '~/pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/components/Form/constants';
import { ConsumptionFormValue, FormValues, Value } from '~/pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/components/Form/types';
import { GetGoalsResponse } from '~/pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/types';
import { formatNumberWithFractionDigits } from './thousandFormatNumber';

export async function getEnergyGoals(reqParams: ApiParams['/energy/get-goals']): Promise<ApiResps['/energy/get-goals']> {
  try {
    const response = await apiCall('/energy/get-goals', reqParams);

    return response;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export function prepareAllUnitDataToForm(data: GetGoalsResponse): FormValues {
  const response: FormValues = {};
  const currentYear = new Date().getFullYear();
  const orderedData = [...data].sort((a, b) => a.YEAR - b.YEAR);

  const minYear = orderedData[0].YEAR;
  let lastPastYearData: GetGoalsResponse[number] | undefined;

  for (let year = minYear; year <= currentYear; year += 1) {
    const item = orderedData.find((item) => item.YEAR === year);

    if (item && lastPastYearData) {
      const merge = mergePastGoalsIntoCurrentYear(lastPastYearData, item);
      response[item.YEAR] = merge.currentYear;
      lastPastYearData = item;
      continue;
    }
    if (item) {
      response[year.toString()] = {
        ...defaultConsumptionFormValue,
        ...prepareGoalsToFormGoals(item.GOALS),
      };
      lastPastYearData = item;
      continue;
    }

    if (lastPastYearData) {
      const merge = mergePastGoalsIntoCurrentYear(lastPastYearData);
      response[year.toString()] = merge.currentYear;
    }
  }

  const futureData = orderedData.filter((item) => item.YEAR > currentYear);

  if (futureData.length > 0) {
    for (const item of futureData) {
      response[item.YEAR.toString()] = {
        ...defaultConsumptionFormValue,
        ...prepareGoalsToFormGoals(item.GOALS),
      };
    }
  }

  return response;
}

function mergePastGoalsIntoCurrentYear(pastData: GetGoalsResponse[number], currentData?: GetGoalsResponse[number]): {
  pastYear: ConsumptionFormValue;
  currentYear: ConsumptionFormValue;
} {
  const pastFormGoals = prepareGoalsToFormGoals(pastData.GOALS);
  const currentGoals = currentData ? prepareGoalsToFormGoals(currentData.GOALS) : {};

  const preparedPastGoals: ConsumptionFormValue = {} as ConsumptionFormValue;

  if (pastData.GOALS.length > 0) {
    for (const [key, value] of Object.entries(pastFormGoals)) {
      preparedPastGoals[key] = {
        ...value,
        past: 'true',
        id: undefined,
      } as Value;
    }
  }

  const currentFormValues: ConsumptionFormValue = {
    ...preparedPastGoals,
    ...currentGoals,
  };

  return {
    pastYear: { ...defaultConsumptionFormValue, ...pastFormGoals },
    currentYear: { ...defaultConsumptionFormValue, ...currentFormValues },
  };
}

function prepareGoalsToFormGoals(goals: GetGoalsResponse[number]['GOALS']): ConsumptionFormValue {
  const response: ConsumptionFormValue = {} as ConsumptionFormValue;

  for (const goal of goals) {
    response[parseMonthValue(goal.MONTH)] = {
      value: formatValueKwhToString(goal.VALUE_KWH),
      updatedAt: goal.UPDATED_AT,
      id: goal.GOAL_ID.toString(),
    } as Value;
  }

  return response;
}

function parseMonthValue(month: number): string {
  return months[month - 1];
}

function formatValueKwhToString(value: number): string {
  return formatNumberWithFractionDigits(value, { minimum: 0, maximum: 2 });
}
